'use strict';

var GetIntrinsic$1 = require('../GetIntrinsic.js');
var index = require('../../../../has/src/index.js');

var GetIntrinsic = GetIntrinsic$1;

var has = index;

var $assign = GetIntrinsic('%Object%').assign;

var assign = function assign(target, source) {
	if ($assign) {
		return $assign(target, source);
	}

	// eslint-disable-next-line no-restricted-syntax
	for (var key in source) {
		if (has(source, key)) {
			target[key] = source[key];
		}
	}
	return target;
};

module.exports = assign;
